module.exports = __webpack_public_path__ + "img/sthzhb.acd87603.png";